export var URL_PREFIXES = {
    BETA_URL_PREFIX: "carrierlogistics.integ",
    GAMMA_URL_PREFIX: "carrierlogistics-gamma.aka",
    PROD_URL_PREFIX: "carrierlogistics.amazon"
};
export var CLWS_CORAL_CONFIG = {
    BETA_CONFIG: "Carrierlogistics.Beta.USAmazon",
    GAMMA_CONFIG: "Carrierlogistics.Gamma.USAmazon",
    PROD_CONFIG: "Carrierlogistics.Prod.USAmazon",
    LOCAL_DEV: "test.USAmazon"
};

//# sourceMappingURL=endpointConfig.js.map